
export const state = {
    projectTypesOptions: [],
    profileData:[],
    roleSkills: [],
    assessments: {},
    assessmentInvitation: ''
  };

 